export const SET_LOGGEDIN_USER		= "SET_LOGGEDIN_USER";
export const SET_USER_OPTIONS		= "SET_USER_OPTIONS";
export const SET_NOTIFICATION_TYPES	= "SET_NOTIFICATION_TYPES";

export const actionAuthenticate	= user => ({ type: SET_LOGGEDIN_USER, user:user });
export const actionSetUserOptions	= options => ({ type: SET_USER_OPTIONS, options:options });
export const actionSetNotificationTypes	= types => ({ type: SET_NOTIFICATION_TYPES, types:types });
